import axios from 'axios'

export default {
  name: 'yldn',
  components: {},
  data () {
    return {
      heroList: [
        {
          name: '成贻宾',
          code: '%E6%88%90%E8%B4%BB%E5%AE%BE',
          sysId: '25'
        }, {
          name: '恽代英',
          code: '%E6%81%BD%E4%BB%A3%E8%8B%B1',
          sysId: '26'
        }, {
          name: '邓中夏',
          code: '%E9%82%93%E4%B8%AD%E5%A4%8F',
          sysId: '27'
        }, {
          name: '许包野',
          code: '%E8%AE%B8%E5%8C%85%E9%87%8E',
          sysId: '28'
        }, {
          name: '黄励',
          code: '%E9%BB%84%E5%8A%B1',
          sysId: '29'
        }, {
          name: '罗登贤',
          code: '%E7%BD%97%E7%99%BB%E8%B4%A4',
          sysId: '30'
        }, {
          name: '金佛庄',
          code: '%E9%87%91%E4%BD%9B%E5%BA%84',
          sysId: '31'
        }, {
          name: '侯绍裘',
          code: '%E4%BE%AF%E7%BB%8D%E8%A3%98',
          sysId: '32'
        }, {
          name: '成贻宾',
          code: '%E6%88%90%E8%B4%BB%E5%AE%BE',
          sysId: '25'
        }, {
          name: '恽代英',
          code: '%E6%81%BD%E4%BB%A3%E8%8B%B1',
          sysId: '26'
        }, {
          name: '邓中夏',
          code: '%E9%82%93%E4%B8%AD%E5%A4%8F',
          sysId: '27'
        }
      ],
      HeroIp: 'http://files.travel-yuhuatai.com:84'
    }
  },
  // 创建元素
  mounted () {
    this.getHero()
  },
  // 方法定义
  methods: {
    // 获取英烈数据
    getHero () {
      const self = this
      axios.get('/yuhuamenhu/heroesAndMartyrs/getDateFromQWLSK').then(json => {
        if (json.data.code === 200) {
          const list = json.data.data
          if (list.length > 0) {
            this.heroList = [...list, ...list.slice(0, 3)]
          }
        } else {
          self.$message.warning(json.data.errorMessage)
        }
      }).catch(err => {
        console.log(err)
      })
    },

    // 点击前往更多
    goMore () {
      const url = this.HeroIp + '/martyr'
      window.open(url, '_blank')
    },

    // 点击前往英烈详情
    goHero (item) {
      const url = `${this.HeroIp}/martyr-info?dbCode=QWLSK&sysId=${item.sysId}&person=${item.name}`
      window.open(url, '_blank')
    }
  }
}
